import { render, staticRenderFns } from "./BookInvoice.vue?vue&type=template&id=57c1823c&"
import script from "./BookInvoice.vue?vue&type=script&lang=js&"
export * from "./BookInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports